// c_terms-check.js 

function waitForElement(selector, callback) {
  const el = document.querySelectorAll(selector);
  if (el.length) {
    callback(el);
  } else {
    setTimeout(() => waitForElement(selector, callback), 100);
  }
}

function setupTermsAgreement(checkboxes) {
  checkboxes.forEach((checkbox) => {
    const formWrapper = checkbox.closest('.ajax-cart__form-wrapper');
    const checkoutBtn = formWrapper?.querySelector('.ajax-cart__button-submit');

    if (!formWrapper || !checkoutBtn) return;

    // 初期状態反映
    checkoutBtn.disabled = !checkbox.checked;

    // changeイベント
    checkbox.addEventListener('change', function () {
      checkoutBtn.disabled = !this.checked;
    });
  });
}

function updateCheckoutDisabled() {
  document.querySelectorAll('#c_agree-terms').forEach((checkbox) => {
    const formWrapper = checkbox.closest('.ajax-cart__form-wrapper');
    const checkoutBtn = formWrapper?.querySelector('.ajax-cart__button-submit');

    if (checkoutBtn) {
      checkoutBtn.disabled = !checkbox.checked;
    }
  });
}

// DOM読み込み後 / ajax更新後
document.addEventListener('DOMContentLoaded', () => {
  waitForElement('#c_agree-terms', setupTermsAgreement);
});
document.addEventListener('ajaxCart:updated', () => {
  waitForElement('#c_agree-terms', setupTermsAgreement);
});


document.addEventListener('change', function (e) {
  if (e.target && e.target.id === 'c_agree-terms') {
    const formWrapper = e.target.closest('.ajax-cart__form-wrapper');
    const checkoutBtn = formWrapper?.querySelector('.ajax-cart__button-submit');
    if (checkoutBtn) {
      checkoutBtn.disabled = !e.target.checked;
    }
  }
});


waitForElement('.ajax-cart__form-wrapper', (formWrappers) => {
  formWrappers.forEach((wrapper) => {
    const observer = new MutationObserver(() => {
      updateCheckoutDisabled();
    });
    observer.observe(wrapper, { childList: true, subtree: true });
  });
});
